class CabinetsCollection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initCabinetsCollection();

    const collection = this.querySelector(
      '[data-section-type="cabinets-collection"]'
    );
    document.body.dispatchEvent(
      new CustomEvent("collection:initCollection", {
        detail: {
          collection: collection,
        },
      })
    );
  }

  disconnectedCallback() {
    localStorage.setItem(
      "builder:cartFormArr",
      JSON.stringify(window.cartFormArr)
    );
  }

  initCabinetsCollection() {
    this.builder = document.querySelector(".collection");
    this.prevBtns = document.querySelectorAll(
      '[data-action="prev-step"], [aria-controls="panel-options"] a'
    );
    this.nextBtns = document.querySelectorAll(
      '[data-action="next-step"], [aria-controls="panel-accessories"] a'
    );
    this.summeryListEl = document.querySelector(".cabinets-summery-list ul");

    this.totalPrice = 0;

    try {
      window.cartFormArr =
        window.cartFormArr ||
        JSON.parse(localStorage.getItem("builder:cartFormArr")) ||
        [];
    } catch (e) {
      localStorage.removeItem("builder:cartFormArr");
      window.cartFormArr = [];
    }

    document.addEventListener("collection:updated", () => {
      setTimeout(() => {
        //this.updateUi();
        this.attachEvents();
      }, 0);
    });

    setTimeout(() => {
      this.updateUi();
      this.attachEvents();
      this.updateBtnState();
    }, 10);

    try {
      window.cabinetHingesColor =
        this.getQueryParams(window.location.search)["hinges"] ||
        localStorage.getItem("builder:hinges");
      /*A- code*/ window.drawerColor = localStorage.getItem(
        "builder:drawer color"
      );
      window.doorStyle =
        this.getQueryParams(window.location.search)["doorStyle"] ||
        localStorage.getItem("builder:doorStyle");
      window.KBdoorColor =
        this.getQueryParams(window.location.search)["doorColor"] ||
        localStorage.getItem("builder:doorColor");
      window.KBcabinetColor =
        this.getQueryParams(window.location.search)[
          "filter.v.option.cabinet colour"
        ] || localStorage.getItem("filter.v.option.cabinet colour");
      window.KBcabinetColorCode = localStorage.getItem(
        "filter.v.option.cabinet colourCode"
      );
      window.KBcabinetColorImage = localStorage.getItem(
        "filter.v.option.cabinet colourImage"
      );
    } catch (e) {
      // document.querySelector('[aria-controls="panel-style"] a').click();
    }
    if (!window.cabinetHingesColor) {
      //  document.querySelector('[aria-controls="panel-style"] a').click();
    }

    this.prevBtns.forEach((item, i) => {
      item.addEventListener("click", (evt) => {
        evt.preventDefault();
        //  window.prevStep = `${window.prevStep}?doorStyle=${window.doorStyle}&doorColor=${window.KBdoorColor}`;
        //   var prevStep = window.prevStep;
        //   window.location.href = prevStep;
      });
    });

    this.nextBtns.forEach((item, i) => {
      item.addEventListener("click", (evt) => {
        evt.preventDefault();
        // this.loadAccessories();
        this.directToAccessories();
      });
    });

    document.querySelector(
      '.doors-thumbs [aria-controls="panel-door"] a'
    ).href = localStorage.getItem("builder:doorColorPage");
  }

  // Function to direct the user to the Accessories page without using Ajax request
  directToAccessories() {
    const AccessoriesCollURL = document.querySelector(
      '[aria-controls="panel-accessories"] a'
    ).href;
    const newUrl = new URL(AccessoriesCollURL, window.location.origin);
    //newUrl.searchParams.set('filter.p.m.hp-filter.accessories_door_style', 'All Styles');
    // newUrl.searchParams.set('filter.p.m.hp-filter.accessories_door_style', window.doorStyle);

    // window.location.href = newUrl.toString();
  }

  attachEvents() {
    window.setQtyBlocksLiseners(); // theme.js
    this.attachRemoveListener();
    this.querySelectorAll(".quantity-selector__kitchen-builder").forEach(
      (input) =>
        input.addEventListener("change", (evt) => {
          this.onQtyInputChange(evt);
        })
    );

    this.querySelectorAll(".hinge-side-select-js").forEach((input) =>
      input.addEventListener("change", (evt) => {
        this.onHingeSideChange(evt);
        this.updateAtcBtnLabel(evt);
      })
    );

    this.querySelectorAll('[data-action="cabinet-add-to-cart"]').forEach(
      (input) =>
        input.addEventListener("click", (evt) => {
          this.onQtyAdd(evt);
          localStorage.setItem(
            "builder:cartFormArr",
            JSON.stringify(window.cartFormArr)
          );
          this.attachRemoveListener();
          this.updateBtnState();
          this.updateAtcBtnLabel(evt);
        })
    );

    preventQty();
    setTimeout(function () {
      document.querySelector(".mini-cart__button-container").style.display =
        "none";
    }, 200);
  }

  attachRemoveListener() {
    const summeryItems = document.querySelectorAll(`.builder-remove-btn`);
    summeryItems.forEach((item) => {
      item.addEventListener("click", (evt) => {
        this.removeItem(evt.target.dataset.itemId, true);
      });
    });
    // summeryItem.addEventListener('click', evt => {console.log(evt); this.removeItem(evt.target.dataset.itemId, true)} )
  }

  onHingeSideChange(evt) {
    var target = evt.currentTarget || evt.target;
    var productInfo = target.closest(".cabinet-item-info-js");
    productInfo
      .querySelectorAll("[data-hinge-side]")
      .forEach((item) => item.classList.add("tw-hidden"));

    console.log("evt.currentTarget.value", evt.currentTarget.value);

    productInfo
      .querySelector(`[data-hinge-side=${evt.currentTarget.value}]`)
      .classList.remove("tw-hidden");
  }

  onQtyInputChange(evt) {
    var target = evt.currentTarget || evt.target;

    var productInfo = target.closest(".cabinet-item-info-js");
    // console.log('productInfo', productInfo);
    // console.log(target);
    var atcBtn = productInfo.querySelector("[data-button-id]");
    // console.log(atcBtn);
    var qty = parseInt(target.value);
    // console.log(qty);
    if (qty > 0) {
      atcBtn.removeAttribute("disabled");
    } else {
      atcBtn.setAttribute("disabled", "");
    }

    // this.updateAtcBtnState(evt)
  }

  onQtyAdd(evt) {
    var atcBtn = evt.target;
    var productInfo = atcBtn.closest(".cabinet-item-info-js");
    if (productInfo.querySelector(".hinge-side-select-js")) {
      var selectedSide = productInfo.querySelector(
        ".hinge-side-select-js"
      ).value;
      var target = atcBtn
        .closest(".cabinet-item-info-js")
        .querySelector(`[name="quantity"][data-hinge-side="${selectedSide}"]`);
    } else {
      var target = atcBtn
        .closest(".cabinet-item-info-js")
        .querySelector('[name="quantity"]');
    }

    var qty = parseInt(target.value);
    this.labelQtyInput(qty, target);
    if (qty == 0) this.removeItem(target.dataset.variantId);

    // this.querySelectorAll('.js-SelectedItems').forEach((el, i) => {
    var el = target;
    var varId = el.dataset.variantId;
    var selectorId = varId.split("-")[0];
    var varPrice = parseInt(el.dataset.price);
    var hingesCount = parseInt(el.dataset.hinges) || 1;
    var drawersCount = parseInt(el.dataset.drawers) || 1;
    var qty = parseInt(el.value);
    if (document.querySelector('[name="' + selectorId + '-hinge-side"]')) {
      var hingesSide = document.querySelector(
        '[name="' + selectorId + '-hinge-side"]'
      ).value;
    }
    ///*H- code*/var drawersInput = document.querySelector('[name="'+ varId +'-drawer"]');
    /*A- code*/ var isDrawer = target.hasAttribute("data-has-drawer");
    ///*H- code*/var drawersOptions = document.querySelectorAll('[name="'+ varId +'-drawer"] option');
    var overhangInput = document.querySelector(
      '[name="' + selectorId + '-overhang"]'
    );
    var isBlackHinges = window.cabinetHingesColor.indexOf("Black") > -1;
    /*A- code*/ var isGraphite = window.drawerColor.indexOf("graphite") > -1;
    var item = {
      id: varId,
      quantity: qty,
      hingesCount: hingesCount,
      drawersCount: drawersCount,
      properties: {
        "Hinges color": window.cabinetHingesColor,
        "Hinges side": hingesSide,
      },
      isBlackHinges: isBlackHinges,
      price: varPrice,
      title: el.dataset.title,
    };
    if (overhangInput) {
      if (overhangInput.checked) {
        item.properties["Overhang"] = "Add Overhang";
      }
    }
    // if (drawersInput) {
    //   item.properties['Drawer'] = drawersInput.value;
    //   if ( drawersInput.selectedIndex == (drawersOptions.length - 1) ) item['isGraphiteDrawers'] = true;
    // }
    if (isDrawer) {
      item.properties["isGraphiteDrawers"] = isGraphite;
      item.properties["Drawer"] = drawerColor;
    }

    item["totalPrice"] = this.calcItemPrice(item) || 0;
    this.updateCartFormArr(item);
    this.displayItemSummery(
      el.dataset.title,
      item["totalPrice"],
      varId,
      item["quantity"],
      item["properties"]["Hinges side"]
    );
    // });

    // reset quantity
    // target.value = 0;
    // target.dispatchEvent(new Event('change'));
  }

  updateCartFormArr(newItem) {
    if (newItem.quantity === 0) return this.removeItem(newItem.id);
    let itemfound = false;
    window.cartFormArr.forEach((item, i) => {
      if (item.id === newItem.id) {
        window.cartFormArr[i] = newItem;
        itemfound = true;
      }
    });
    if (!itemfound) window.cartFormArr.push(newItem);
  }

  displayItemSummery(title, price, id, qty, hingeSide) {
    const existingItem = document.getElementById(`summery-item-${id}`);
    var priceMoney = window.theme.Currency.formatMoney(
      price,
      window.theme.moneyFormat
    );
    var newLi = document.createElement("li");
    newLi.id = `summery-item-${id}`;
    newLi.innerHTML = `<span class="builder-remove-btn" role="button" title="Remove" data-item-id="${id}"> </span> <span>${title}`;
    newLi.innerHTML += hingeSide != undefined ? ` (H-${hingeSide}): ` : "";
    newLi.innerHTML += `</span> <span><b>(x${qty}) ${priceMoney} </b> </span> , `;
    if (existingItem) {
      existingItem.innerHTML = newLi.innerHTML;
    } else {
      document.querySelector(".cabinets-summery-list ul").append(newLi);
    }

    // this.attachRemoveListener(id);
  }

  updateBtnState() {
    if (window.cartFormArr.length > 0) {
      this.nextBtns.forEach((btn) => btn.removeAttribute("disabled"));
    } else {
      this.nextBtns.forEach((btn) => btn.setAttribute("disabled", "disabled"));
    }
  }

  // Update the ATC button depending on the product status
  updateAtcBtnLabel(evt) {
    var target = evt.currentTarget || evt.target;
    var productInfo = target.closest(".cabinet-item-info-js");

    if (productInfo) {
      // Use the wrapper to select the atc button and update it if the QTY changed
      var atcBtn = productInfo.querySelector(
        "[data-action='cabinet-add-to-cart']"
      );
      var varId = productInfo
        .querySelector(".quantity-selector__kitchen-builder:not(.tw-hidden)")
        .getAttribute("data-variant-id");
      var summaryItem = document.getElementById(`summery-item-${varId}`);

      if (summaryItem) {
        atcBtn.innerText = "Update item";
      } else {
        atcBtn.innerText = "Add item";
      }
    }
    // console.log(summaryItem);
  }

  calcItemPrice(item) {
    var price = 0;
    price += item.quantity * item.price;
    price += item.isBlackHinges
      ? item.quantity * item.hingesCount * blackHingesProductPrice
      : 0;
    price += item.properties["isGraphiteDrawers"]
      ? item.quantity * item.drawersCount * graphiteDrawerProductPrice
      : 0;
    price += item.properties["Overhang"] ? overhangProductPrice : 0;
    // /*A- code*/price += item.properties['isGraphite'] ? graphiteDrawerProductPrice : 0;
    // console.log('price', price);
    return price;
  }

  updateUi() {
    window.cartFormArr.forEach((item) => {
      this.displayItemSummery(
        item.title,
        item.totalPrice,
        item.id,
        item.quantity,
        item.properties["Hinges side"]
      );
      const input = document.querySelector(
        `.quantity-selector__kitchen-builder[data-variant-id="${item.id}"]`
      );
      const hingSelector = document.querySelector(
        `[name="${item.id.split("-")[0]}-hinge-side"]`
      );
      console.log("cart item Id: ", item.id.split("-")[0]) /
        console.log("Hing Selector: ", hingSelector);
      if (input) {
        input.value = parseInt(item.quantity);
        input.classList.add("js-SelectedItems");
        //To make the page recognize the change in the input so the ATC become active
        setTimeout(() => {
          input.dispatchEvent(new Event("change"));
        }, 100);
      }

      if (hingSelector) {
        hingSelector.value = item.properties["Hinges side"];
        setTimeout(() => {
          hingSelector.dispatchEvent(new Event("change"));
        }, 100);
      }
    });
  }

  labelQtyInput(qty, input) {
    if (input.classList.contains("js-SelectedItems") && qty == 0) {
      input.classList.remove("js-SelectedItems");
    } else if (qty > 0) {
      input.classList.add("js-SelectedItems");
    }
  }

  removeItem(id, hardRemove) {
    if (!window.cartFormArr.length > 0) return;
    for (var i = 0; i < window.cartFormArr.length; i++) {
      var itemId = parseInt(window.cartFormArr[i].id);

      if (itemId == id) {
        window.cartFormArr.splice(i, 1);
        this.querySelector(
          `[name="quantity"][data-variant-id="${id}"]`
        ).classList.remove("js-SelectedItems");
        i--;
      }
    }
    setTimeout(() => {
      localStorage.setItem(
        "builder:cartFormArr",
        JSON.stringify(window.cartFormArr)
      );
    }, 0);
    var input = document.querySelector(
      `[name="quantity"][data-variant-id="${id}"]`
    );
    var summerItem = document.getElementById(`summery-item-${id}`);
    if (input && hardRemove) input.value = 0;
    if (summerItem) summerItem.remove();
  }

  getQueryParams(qs) {
    qs = qs.split("+").join(" ");
    var params = {},
      tokens,
      re = /[?&]?([^=]+)=([^&]*)/g;
    while ((tokens = re.exec(qs))) {
      params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }
    return params;
  }

  loadAccessories() {
    var computedStyles = window.getComputedStyle(document.documentElement);

    const sectionId = this.querySelector(
      '[data-section-type="cabinets-collection"]'
    ).dataset.sectionId;
    const cabinetsSection = document.getElementById(
      `shopify-section-${sectionId}`
    );
    const AccessoriesCollURL = this.querySelector(
      '[aria-controls="panel-accessories"] a'
    ).href;
    const newUrl = new URL(AccessoriesCollURL, window.location.origin);
    newUrl.searchParams.set(
      "filter.p.m.hp-filter.accessories_door_style",
      "All Styles"
    );
    newUrl.searchParams.set(
      "filter.p.m.hp-filter.accessories_door_style",
      window.doorStyle
    );
    const AccessoriesSectionsURL =
      AccessoriesCollURL + "/?section_id=collection-cabinets-accessories";

    document.dispatchEvent(new CustomEvent("theme:loading:start"));

    fetch(AccessoriesCollURL)
      .then((res) => res.text())
      .then((content) => {
        window.history.pushState(
          {
            path: newUrl.toString(),
          },
          "",
          newUrl.toString()
        );

        const tempElement = document.createElement("div");
        tempElement.innerHTML = content;
        const accessSection = tempElement.querySelector(
          ".kb-collection-cabinets-accessories"
        );
        cabinetsSection.parentNode.replaceChild(accessSection, cabinetsSection);
        // START Call the function that show the selected door and Kitchen
        accessoriesUpdateSelectedDoor();
        cabinetUpdateSelectedKithchen();
        // END Call the function that show the selected door
        //  document.querySelector('[aria-controls="panel-cabinets"] a').href =
        //window.location.href;
        // console.log(window.location.href);

        document.dispatchEvent(new CustomEvent("theme:loading:end"));

        var elementOffset =
          this.querySelector(".collection").getBoundingClientRect().top -
          25 -
          parseInt(computedStyles.getPropertyValue("--header-is-sticky")) *
            parseInt(computedStyles.getPropertyValue("--header-height"));

        if (elementOffset < 0) {
          window.scrollBy({
            top: elementOffset,
            behavior: "smooth",
          });
        } // Finally, we scroll to the element
      })
      .catch((error) => {
        console.error(error);
      });
  }
}

customElements.define("cabinets-collection", CabinetsCollection);

try {
  document
    .querySelectorAll(".custom-svg-image svg path.side")
    .forEach((item) => {
      item.style.fill = window.KBcabinetColorCode;
    });

  document
    .querySelectorAll(".custom-svg-image svg pattern#door image")
    .forEach((item) => {
      item.setAttribute("href", window.KBdoorColorImage);
    });

  document
    .querySelectorAll(".custom-svg-image svg path.cls-2")
    .forEach((item) => {
      item.style.fill = window.KBdoorColorCode;
    });

  document
    .querySelectorAll(".custom-svg-image svg pattern#cabinate-color image")
    .forEach((item) => {
      item.setAttribute("href", window.KBcabinetColorImage);
    });
} catch (err) {
  console.log(err);
}
